import React, {
  useMemo,
  forwardRef,
  useRef,
  useContext,
  useImperativeHandle,
  useEffect,
} from 'react';
import {
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  useTheme,
  Button,
} from '@material-ui/core';
import { useForm, Controller } from 'react-hook-form';
import { useIntl } from 'umi';
import { Context } from '../../AddMarketing';
import MemberLevel from './member_level/index';
import AllMemberLevel from './all_member_level/index';
import ActivityEquityStyled from './ActivityEquityStyled';
export default forwardRef((props) => {
  const theme = useTheme();
  const intl = useIntl();
  const { formatMessage } = intl;
  const {
    levelRulesList: levelRulesListJSONWithStr = [],
    setLevelRulesList,
    benefitType,
    setBenefitType,
    opt,
    onSubmit,
    id,
    memberLevel,
    allLevelData,
    setAllLevelData = () => {},
    setIsSave,
    isAllGoods,
  } = props;
  console.log('isAllGoods', isAllGoods);

  const { ref } = useContext(Context);
  const { handleSubmit, errors, control, setValue } = useForm();

  useEffect(() => {
    setValue('isAllGoods', isAllGoods);
  }, [isAllGoods]);
  const submitRef = useRef();
  const clickInput = () => {
    submitRef.current.click();
  };

  useImperativeHandle(ref, () => ({
    // handleSubmit 就是暴露给父组件的方法
    clickInput: clickInput,
  }));
  const levelRulesListJSONObj = useMemo(() => {
    let newArr = [];
    if (levelRulesListJSONWithStr) {
      newArr = levelRulesListJSONWithStr;
      newArr.forEach((element) => {
        if (typeof element?.coupons === 'string') {
          const reg = /\\/g;
          element['coupons'] = JSON.parse(element?.coupons?.replace(reg));
        }
      });
    }
    return newArr;
  }, [levelRulesListJSONWithStr]);

  const levelData = [
    {
      id: 0,
      name: formatMessage({ id: 'marketing.scene.holiday.c02.lbl01' }),
    },
    {
      id: 4,
      // name: '送优惠券',
      name: formatMessage({ id: 'marketing.scene.holiday.c02.lbl05' }),
    },
    {
      id: 5,
      // name: '状态',
      name: formatMessage({ id: 'marketing.scene.holiday.c02.lbl06' }),
    },
  ];

  const levelDataTitle = (
    <span className="level-title-wrap">
      {levelData &&
        levelData.map((title) => {
          return <div>{title.name}</div>;
        })}
    </span>
  );

  return (
    <ActivityEquityStyled theme={theme} disabled={opt === 'detail'}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="basic-title">
          {formatMessage({ id: 'marketing.scene.holiday.n02.lbl01' })}
        </div>
        <FormLabel component="legend" className="basic-cycle">
          <span className="label-require">*</span>
          {formatMessage({ id: 'marketing.scene.holiday.n02.chb02' })}
        </FormLabel>
        <Controller
          render={(rp) => (
            <RadioGroup
              className="checkbox-radio-disabled-color cycle-select-wrap"
              aria-label="date"
              name="customized-radios"
              onChange={(e) => {
                setBenefitType(e.target.value);
                return rp.onChange(e.target.value);
              }}
              value={benefitType}
            >
              <div>
                <FormControlLabel
                  value="SAME"
                  control={
                    <Radio
                      className="checkbox-radio-disabled-color"
                      color="primary"
                      disabled={opt === 'detail'}
                    />
                  }
                  color="primary"
                  label={formatMessage({
                    id: 'marketing.scene.holiday.n02.rdo03',
                  })}
                  className="all-level-select"
                />
              </div>
              {/* 全部等级 */}
              {levelDataTitle}
              <AllMemberLevel
                opt={opt}
                id={id}
                allLevelData={allLevelData}
                setAllLevelData={setAllLevelData}
                setIsSave={setIsSave}
              ></AllMemberLevel>
              <div>
                <FormControlLabel
                  value="NOT_SAME"
                  control={
                    <Radio
                      className="checkbox-radio-disabled-color"
                      color="primary"
                      disabled={opt === 'detail'}
                    />
                  }
                  color="primary"
                  label={formatMessage({
                    id: 'marketing.scene.holiday.n03.rdo01',
                  })}
                  className="different-level-select"
                />
              </div>
              {levelDataTitle}
              {/* 不同等级 */}
              <MemberLevel
                opt={opt}
                id={id}
                errors={errors}
                memberLevelData={
                  levelRulesListJSONObj?.length > 1
                    ? levelRulesListJSONObj
                    : memberLevel
                }
                // setMemberLevel={
                //   benefitType === 'NOT_SAME' ? setLevelRulesList : () => {}
                // }
                setMemberLevel={setLevelRulesList}
                setIsSave={setIsSave}
              ></MemberLevel>
            </RadioGroup>
          )}
          control={control}
          name="benefitType"
        />
        <Button type="submit" ref={submitRef} style={{ display: 'none' }} />
      </form>
    </ActivityEquityStyled>
  );
});
